module.exports = __webpack_public_path__ + "img/card-heading.d3610ce3.svg";